define([
    "dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi",
	"csi/expander/Widget",
	"csi/xml"
], function(array,declare,lang,when,csi,Widget,xml) {

    var QUESTION = "ORQuestion";
    var SUBQUESTION = "ORSubQuestion";
	var MAX_LEVEL = 5;	// ROOT/SECTION/SUBSECTION/QUESTION/SUBQUESTION

    function _questionHasApplicableSubQuestions(/*Context*/ctx, /*Node?*/question) {
		question = question || ctx.getNode();

		var subQuestions = ctx.cache.getNodes(question.SubQuestions);

		return array.some(subQuestions, function(subQuestion) {
			var	sqSpec = ctx.cache.getNode(subQuestion.Spec);
			return xml.enumGetText(question.Response) == xml.enumGetText(sqSpec.ApplicableQuestionResponse);
		});
	};

	return declare(Widget, {
		// Boolean: don't allow custom view to set expand level; instead, always show all levels
		bSupportsExpandLevelOption: false,

		onAccessResponse: function(/*Context*/ctx, /*Action*/action) {
			// summary: on Questions, check if NotApplicable is checked before allowing editing on Response;
			// on Sub-Questions, only allow Response if there is a subQuestion for this response
			var	na = ctx.getNodeAttributeValue("NotApplicable");
			return (na == null) ? _questionHasApplicableSubQuestions(ctx, ctx.getParent()) : !na;
		},

		onViewPreferences: function() {
			// summary: post-process view settings after loading custom view
			this.inherited(arguments);

			// if expandLevel set to default, then force expand all if on conclusion view, or to second level otherwise
			if (this.expandLevel == 1) {
				this.set("expandLevel", this.getToolbarContainerView(true) ? MAX_LEVEL : 2);
			}
		},

		postActionResponse: function(/*Controller*/ac) {
			// summary: if Question.Response is No, then show SubQuestions (if any); also, refresh parent rows to show new rollup values
			var	refNode = this.getRefNode(ac.refNode);
			this.refreshParentRows(refNode);
			return this.refreshHierarchyRow(refNode, true);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: customize which question will appear and which have sub questions
			var	ql = this.inherited(arguments);
			var	cache = this.cacheView;

			if (ql.type == QUESTION) {
				ql.hasChildrenTest = _questionHasApplicableSubQuestions;
			} else if (ql.type == SUBQUESTION) {
				ql.clientAdHocQuery = {
					"__Test__": {
						test: function(value, orsq) {
							var	orq = cache.getNode(orsq.__Parent__);
                            var sq = cache.getNode(orsq.Spec);
                            return xml.enumGetText(orq.Response) == xml.enumGetText(sq.ApplicableQuestionResponse);
						}
					}
				};
			}

			return ql;
		}
	});
});